// ISO 3166-1 alpha-2 country codes and ISO 639-1 language codes, keyed by
// lowercased English name for lookup. Used to turn Optimizely choice names
// (e.g. "United States", "English") into short codes (e.g. "US", "EN").

export const COUNTRY_CODES = {
    'afghanistan': 'AF', 'albania': 'AL', 'algeria': 'DZ', 'andorra': 'AD', 'angola': 'AO',
    'argentina': 'AR', 'armenia': 'AM', 'australia': 'AU', 'austria': 'AT', 'azerbaijan': 'AZ',
    'bahamas': 'BS', 'bahrain': 'BH', 'bangladesh': 'BD', 'belarus': 'BY', 'belgium': 'BE',
    'belize': 'BZ', 'benin': 'BJ', 'bhutan': 'BT', 'bolivia': 'BO', 'bosnia and herzegovina': 'BA',
    'botswana': 'BW', 'brazil': 'BR', 'brunei': 'BN', 'bulgaria': 'BG', 'burkina faso': 'BF',
    'burundi': 'BI', 'cambodia': 'KH', 'cameroon': 'CM', 'canada': 'CA', 'chad': 'TD',
    'chile': 'CL', 'china': 'CN', 'colombia': 'CO', 'costa rica': 'CR', 'croatia': 'HR',
    'cuba': 'CU', 'cyprus': 'CY', 'czech republic': 'CZ', 'czechia': 'CZ', 'denmark': 'DK',
    'dominican republic': 'DO', 'ecuador': 'EC', 'egypt': 'EG', 'el salvador': 'SV', 'estonia': 'EE',
    'ethiopia': 'ET', 'fiji': 'FJ', 'finland': 'FI', 'france': 'FR', 'georgia': 'GE',
    'germany': 'DE', 'ghana': 'GH', 'greece': 'GR', 'guatemala': 'GT', 'haiti': 'HT',
    'honduras': 'HN', 'hong kong': 'HK', 'hungary': 'HU', 'iceland': 'IS', 'india': 'IN',
    'indonesia': 'ID', 'iran': 'IR', 'iraq': 'IQ', 'ireland': 'IE', 'israel': 'IL',
    'italy': 'IT', 'jamaica': 'JM', 'japan': 'JP', 'jordan': 'JO', 'kazakhstan': 'KZ',
    'kenya': 'KE', 'kuwait': 'KW', 'kyrgyzstan': 'KG', 'laos': 'LA', 'latvia': 'LV',
    'lebanon': 'LB', 'liberia': 'LR', 'libya': 'LY', 'liechtenstein': 'LI', 'lithuania': 'LT',
    'luxembourg': 'LU', 'macau': 'MO', 'madagascar': 'MG', 'malawi': 'MW', 'malaysia': 'MY',
    'maldives': 'MV', 'mali': 'ML', 'malta': 'MT', 'mauritius': 'MU', 'mexico': 'MX',
    'moldova': 'MD', 'monaco': 'MC', 'mongolia': 'MN', 'montenegro': 'ME', 'morocco': 'MA',
    'mozambique': 'MZ', 'myanmar': 'MM', 'namibia': 'NA', 'nepal': 'NP', 'netherlands': 'NL',
    'new zealand': 'NZ', 'nicaragua': 'NI', 'niger': 'NE', 'nigeria': 'NG', 'north korea': 'KP',
    'north macedonia': 'MK', 'norway': 'NO', 'oman': 'OM', 'pakistan': 'PK', 'panama': 'PA',
    'papua new guinea': 'PG', 'paraguay': 'PY', 'peru': 'PE', 'philippines': 'PH', 'poland': 'PL',
    'portugal': 'PT', 'puerto rico': 'PR', 'qatar': 'QA', 'romania': 'RO', 'russia': 'RU',
    'rwanda': 'RW', 'saudi arabia': 'SA', 'senegal': 'SN', 'serbia': 'RS', 'singapore': 'SG',
    'slovakia': 'SK', 'slovenia': 'SI', 'somalia': 'SO', 'south africa': 'ZA', 'south korea': 'KR',
    'south sudan': 'SS', 'spain': 'ES', 'sri lanka': 'LK', 'sudan': 'SD', 'sweden': 'SE',
    'switzerland': 'CH', 'syria': 'SY', 'taiwan': 'TW', 'tajikistan': 'TJ', 'tanzania': 'TZ',
    'thailand': 'TH', 'togo': 'TG', 'trinidad and tobago': 'TT', 'tunisia': 'TN', 'turkey': 'TR',
    'turkmenistan': 'TM', 'uganda': 'UG', 'ukraine': 'UA', 'united arab emirates': 'AE',
    'united kingdom': 'GB', 'united states': 'US', 'uruguay': 'UY', 'uzbekistan': 'UZ',
    'venezuela': 'VE', 'vietnam': 'VN', 'yemen': 'YE', 'zambia': 'ZM', 'zimbabwe': 'ZW'
};

export const LANGUAGE_CODES = {
    'afrikaans': 'AF', 'albanian': 'SQ', 'arabic': 'AR', 'armenian': 'HY', 'azerbaijani': 'AZ',
    'basque': 'EU', 'belarusian': 'BE', 'bengali': 'BN', 'bosnian': 'BS', 'bulgarian': 'BG',
    'catalan': 'CA', 'chinese': 'ZH', 'croatian': 'HR', 'czech': 'CS', 'danish': 'DA',
    'dutch': 'NL', 'english': 'EN', 'estonian': 'ET', 'filipino': 'FIL', 'finnish': 'FI',
    'french': 'FR', 'georgian': 'KA', 'german': 'DE', 'greek': 'EL', 'gujarati': 'GU',
    'hebrew': 'HE', 'hindi': 'HI', 'hungarian': 'HU', 'icelandic': 'IS', 'indonesian': 'ID',
    'italian': 'IT', 'japanese': 'JA', 'kazakh': 'KK', 'khmer': 'KM', 'korean': 'KO',
    'lao': 'LO', 'latvian': 'LV', 'lithuanian': 'LT', 'macedonian': 'MK', 'malay': 'MS',
    'maltese': 'MT', 'mongolian': 'MN', 'nepali': 'NE', 'norwegian': 'NO', 'persian': 'FA',
    'polish': 'PL', 'portuguese': 'PT', 'punjabi': 'PA', 'romanian': 'RO', 'russian': 'RU',
    'serbian': 'SR', 'slovak': 'SK', 'slovenian': 'SL', 'somali': 'SO', 'spanish': 'ES',
    'swahili': 'SW', 'swedish': 'SV', 'tamil': 'TA', 'telugu': 'TE', 'thai': 'TH',
    'turkish': 'TR', 'ukrainian': 'UK', 'urdu': 'UR', 'uzbek': 'UZ', 'vietnamese': 'VI',
    'welsh': 'CY', 'zulu': 'ZU'
};

/**
 * Resolve a country or language display name to its short code.
 * Falls back to the first two letters of the name (uppercased) if unknown.
 */
export function nameToCode(name, codes) {
    if (!name) {
        return '';
    }

    return codes[name.toLowerCase().trim()] || name.slice(0, 2).toUpperCase();
}

// Best-effort default country for a detected BCP-47 language code (lowercase,
// e.g. "en", "fr"). A language can belong to many countries - this just picks
// one sensible default, used to seed the Country select from detected text.
const LANGUAGE_TO_COUNTRY = {
    af: 'ZA', sq: 'AL', ar: 'SA', hy: 'AM', az: 'AZ', eu: 'ES', be: 'BY', bn: 'BD',
    bs: 'BA', bg: 'BG', ca: 'ES', zh: 'CN', hr: 'HR', cs: 'CZ', da: 'DK', nl: 'NL',
    en: 'US', et: 'EE', fil: 'PH', fi: 'FI', fr: 'FR', ka: 'GE', de: 'DE', el: 'GR',
    gu: 'IN', he: 'IL', hi: 'IN', hu: 'HU', is: 'IS', id: 'ID', it: 'IT', ja: 'JP',
    kk: 'KZ', km: 'KH', ko: 'KR', lo: 'LA', lv: 'LV', lt: 'LT', mk: 'MK', ms: 'MY',
    mt: 'MT', mn: 'MN', ne: 'NP', no: 'NO', fa: 'IR', pl: 'PL', pt: 'PT', pa: 'IN',
    ro: 'RO', ru: 'RU', sr: 'RS', sk: 'SK', sl: 'SI', so: 'SO', es: 'ES', sw: 'KE',
    sv: 'SE', ta: 'IN', te: 'IN', th: 'TH', tr: 'TR', uk: 'UA', ur: 'PK', uz: 'UZ',
    vi: 'VN', cy: 'GB', zu: 'ZA'
};

export function defaultCountryForLanguage(languageCode) {
    if (!languageCode) {
        return null;
    }

    return LANGUAGE_TO_COUNTRY[languageCode.toLowerCase().trim()] || null;
}
